// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","572":"component---src-pages-maintenance-tsx"}[chunkId] + "-" + {"245":"05b104e16d537f3aef1c","572":"d7f8c03c5b8b5b77ef62"}[chunkId] + ".js";
};